import React from 'react'
import { FormControl, InputLabel, ListItemText, MenuItem, Select, SelectChangeEvent } from '@mui/material'

export enum ActionSelectorType {
  All = 'All',
  Entity = 'Entity',
  Path = 'Path',
}

type ActionEntitySelectorProps = {
  includePath: boolean
  value: ActionSelectorType | undefined
  onChange: (option: ActionSelectorType) => void
}

const ActionTypeSelector: React.FC<ActionEntitySelectorProps> = ({ includePath, value, onChange }) => {
  const handleChange = (event: SelectChangeEvent<ActionSelectorType>) => {
    onChange(event.target.value as ActionSelectorType)
  }

  return (
    <FormControl
      variant="outlined"
      margin="normal"
      sx={{
        flexShrink: 0,
        width: 'fit-content',
      }}
    >
      <InputLabel id="dropdown-label">Select Option</InputLabel>
      <Select labelId="dropdown-label" value={value ?? ''} onChange={handleChange} label="Select Option">
        <MenuItem value={ActionSelectorType.All}>
          <ListItemText primary="All Entities" />
        </MenuItem>
        <MenuItem value={ActionSelectorType.Entity}>
          <ListItemText primary="Selected Entities" />
        </MenuItem>
        (
        {includePath && (
          <MenuItem value={ActionSelectorType.Path}>
            <ListItemText primary="Path to Entities" />
          </MenuItem>
        )}
        )
      </Select>
    </FormControl>
  )
}

export default ActionTypeSelector
